import React from 'react';

import { Header, SubscribeLink, Title } from './style';

const SignUpHeader = () => (
    <Header>
        <Title>Bull & Bear</Title>
        <SubscribeLink href="http://eepurl.com/g8S8D9" target="_blank" rel="noreferrer noopener">Subscribe</SubscribeLink>
    </Header>
);

export default SignUpHeader;